
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core'
import { TypographyComponent } from '../typography'

@Component({
  selector: 'hyperkit-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  standalone: true,
  imports: [TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleComponent {
  @Input() public isChecked = false
  @Input() public labelLeft = ''
  @Input() public labelRight = ''
  @Input() public disabled = false
  @Output() public changed = new EventEmitter<boolean>()

  public onToggle(): void {
    if (!this.disabled) {
      this.isChecked = !this.isChecked
      this.changed.emit(this.isChecked)
    }
  }
}
